// @flow

const events = {
  breadcrumb: 'click_breadcrumb',
  username: 'click_username',
  infoDialog: 'open_info_dialog',
  termInfoDialog: 'open_term_info_dialog',
  demofabclicked: 'demo_fab_clicked',
  demoSessionStart: 'demo_session_start',
  demoSessionSummary: 'demo_session_end',
};

export {
  // eslint-disable-next-line import/prefer-default-export
  events,
};
